import NumberFormatter from '../../../data/NumberFormatter';

function AllHoldingsCard(props) {
  const columns = props.data.columns.map((item, idx) =>
    <ColumnTitle key={idx} text={item} />
  );
  const entries = props.data.items.map((item, idx) =>
    <Entry key={idx} ticker={item.ticker} currentValue={item.currentValue}
      change={item.change} currentPrice={item.currentPrice}
      targetPrice={item.targetPrice} upsideDownside={item.upsideDownside} />
  );

  return (
    <div className="col-12">
      <div className="card shadow-sm">
        <div className="card-header d-flex flex-row align-items-center flex-0">
          <div className="h4 col text-left">All Holdings</div>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-centered table-nowrap mb-0 rounded">
              <thead className="thead-light">
                <tr>
                  {columns}
                </tr>
              </thead>
              <tbody>
                {entries}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

function ColumnTitle(props) {
  return (<th className="border-0">{props.text}</th>);
}

function formatUpsideDownside(value) {
  if (typeof value !== 'number' || Number.isNaN(value)) {
    return '—';
  }

  const sign = value > 0 ? '+' : '';
  return `${sign}${value.toFixed(1)}%`;
}

function Entry(props) {
  const UpArrow = "fa-arrow-up text-success";
  const DownArrow = "fa-arrow-down text-danger";
  const hasChange = typeof props.change === 'number' && !Number.isNaN(props.change);
  const ArrowToUse = hasChange && props.change > 0 ? UpArrow : DownArrow;
  const upsideDownsideClass = typeof props.upsideDownside === 'number'
    ? (props.upsideDownside > 0 ? 'text-success' : props.upsideDownside < 0 ? 'text-danger' : '')
    : '';

  return (
    <tr>
      <td>{props.ticker}</td>
      <td>{NumberFormatter.format(props.currentValue)}</td>
      <td>
        {hasChange && <span className={"fas mr-3 " + ArrowToUse}></span>}
        {hasChange ? `${props.change}%` : '—'}
      </td>
      <td>
        {typeof props.currentPrice === 'number' ? props.currentPrice.toFixed(2) : '—'}
      </td>
      <td>
        {typeof props.targetPrice === 'number' ? props.targetPrice.toFixed(2) : '—'}
      </td>
      <td className={`font-weight-bold ${upsideDownsideClass}`}>
        {formatUpsideDownside(props.upsideDownside)}
      </td>
    </tr>
  );
}

export default AllHoldingsCard;
